import React, { useState } from 'react';
import useStyles from './styles';

function Switch({onChange, value}) {
  const c = useStyles();
  const [on, setOn] = useState(value || false);


  const switchState = () => {
    onChange(!on);
    setOn(!on);
  }

  React.useEffect(() => {
    setOn(value || false);
  }, [value])

  return (
    
    <div style={on ? {backgroundColor: "#71a1d2"} : {}} className={c.switchContainer} onClick={switchState}>
      <div style={on ? {left: 'calc(100% - 25px)'} : {left: 0}} className={c.indicator}></div>
    </div>
  
  );
}

export default Switch;